import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { convertObjectDateStringsToDate } from "app/common/utils";
import { SKIP_AUTO_DATE_CONVERSION } from "app/dal/api-dates";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class AutoDateConversionInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // The generated API client converts its own response dates based on the OpenAPI schema
        if (req.context.get(SKIP_AUTO_DATE_CONVERSION)) {
            return next.handle(req);
        }

        return next.handle(req).pipe(
            map((event) => {
                if (event instanceof HttpResponse) {
                    event = event.clone({
                        body: convertObjectDateStringsToDate(event.body),
                    });
                }

                return event;
            }),
        );
    }
}
